const _excluded = ["agreementId", "serviceId", "serviceName", "isPaused", "isDisabled", "tooltipTitle"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { useState } from 'react';
import { Switch, Spinner, Typography, ConfirmationModal, useOverlayContext } from 'seagull';
import { useStoreActions } from "../../../../../contexts";
import { timeModel } from "../../../../../models";
import { useBillingObservable } from "../../../../../providers/BillingObservableProvider";
import styles from "../BillingControl.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function PauseBillingConfirmationModal(props) {
  const {
    serviceName,
    dismissModal
  } = props;
  const title = 'Pause automatic billing';
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: title,
    "data-testid": "pause-confirmation-modal",
    textAlignCenter: false,
    width: "701",
    content: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(Typography, {
        children: ["You are about to pause automatic billing for", ' ', /*#__PURE__*/_jsx(Typography, {
          "data-testid": "pause-confirmation-modal-service-name",
          as: "span",
          weight: "bold",
          children: serviceName
        }), "."]
      }), /*#__PURE__*/_jsx(Typography, {
        children: "The service will not be billed until you manually resume automatic billing for it."
      }), /*#__PURE__*/_jsx(Typography, {
        style: {
          marginTop: '1rem'
        },
        children: "Be sure to resume automatic billing several days before the billing date in order to avoid missing the next billing cycle."
      })]
    }),
    primaryButtonLabel: title,
    secondaryButtonLabel: "Cancel",
    onPrimaryButtonClick: () => dismissModal(true),
    onSecondaryButtonClick: () => dismissModal(false)
  });
}
function ResumeBillingConfirmationModal(props) {
  const {
    serviceName,
    nextBillingDate,
    dismissModal
  } = props;
  const title = 'Resume automatic billing';
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: title,
    "data-testid": "resume-confirmation-modal",
    textAlignCenter: false,
    width: "701",
    content: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(Typography, {
        children: ["You are about to activate automatic billing for", ' ', /*#__PURE__*/_jsx(Typography, {
          "data-testid": "resume-confirmation-modal-service-name",
          as: "span",
          weight: "bold",
          children: serviceName
        }), "."]
      }), /*#__PURE__*/_jsxs(Typography, {
        style: {
          marginTop: '1rem'
        },
        children: ["The upcoming invoice to include this service will be on", ' ', /*#__PURE__*/_jsx(Typography, {
          "data-testid": "resume-confirmation-modal-next-billing-date",
          as: "span",
          weight: "bold",
          children: timeModel.formatDate(nextBillingDate)
        }), "."]
      })]
    }),
    primaryButtonLabel: title,
    secondaryButtonLabel: "Cancel",
    onPrimaryButtonClick: () => dismissModal(true),
    onSecondaryButtonClick: () => dismissModal(false)
  });
}
export default function OngoingServiceSwitch(props) {
  const {
      agreementId,
      serviceId,
      serviceName,
      isPaused,
      isDisabled,
      tooltipTitle
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    notifyToRefresh
  } = useBillingObservable();
  const [isResumed, setIsResumed] = useState(!isPaused);
  const [loading, setLoading] = useState(false);
  const overlayContext = useOverlayContext();
  const {
    api
  } = useStoreActions();
  const testid = rest['data-testid'];
  async function onChange(e) {
    const {
      checked,
      value
    } = e.target;
    if (!checked /* pause service */) {
      const confirmed = await overlayContext.showModal({
        content: props => /*#__PURE__*/_jsx(PauseBillingConfirmationModal, _objectSpread(_objectSpread({}, props), {}, {
          serviceName: serviceName
        }))
      });
      if (!confirmed) return;
    } else {
      const nextBillingDate = await api.service.nextBillingDate(agreementId, serviceId);
      const confirmed = await overlayContext.showModal({
        content: props => /*#__PURE__*/_jsx(ResumeBillingConfirmationModal, _objectSpread(_objectSpread({}, props), {}, {
          serviceName: serviceName,
          nextBillingDate: nextBillingDate
        }))
      });
      if (!confirmed) return;
    }
    try {
      setLoading(true);
      await api.service.togglePauseResumeBilling(agreementId, value, !checked);
      notifyToRefresh();
      setIsResumed(checked);
    } catch (error) {
      overlayContext.showErrorToast("Failed to ".concat(checked ? 'resume' : 'pause', " service"), 'pause-service-error-toast');
    } finally {
      setLoading(false);
    }
  }
  return /*#__PURE__*/_jsxs("div", {
    className: styles.switch,
    children: [loading && /*#__PURE__*/_jsx(Spinner, {
      size: 24
    }), /*#__PURE__*/_jsx(Switch, _objectSpread({
      disabled: loading || isDisabled,
      value: serviceId,
      checked: isResumed,
      tooltip: tooltipTitle ? {
        placement: 'top',
        title: /*#__PURE__*/_jsx("div", {
          "data-testid": testid && "".concat(testid, "-tooltip"),
          children: tooltipTitle
        })
      } : undefined,
      onChange: onChange
    }, rest))]
  });
}